import { ColumnHeaderRadioFilter } from "components/ReusableHeaderFilter/ColumnHeaderRadioFilter";
import { useUpdateQuery } from "hooks/useQuery";

export const RadioHeader = ({
  options,
  selected,
  title,
  filterKey,
}: {
  options: { label: string; value: string }[];
  selected: string | null;
  title: string;
  filterKey: string;
}) => {
  const isActive = Boolean(selected);
  const { update } = useUpdateQuery();

  const updateFilter = (filterName: string, value: string) => {
    update({ query: filterName, value });
  };

  const handleClearFilter = (filterName: string) => {
    update({ query: filterName, value: null });
  };

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>{title}</div>
      <ColumnHeaderRadioFilter
        isActive={isActive}
        options={options || []}
        selected={selected || ""}
        onValueChange={(value) => updateFilter(filterKey, value)}
        handleClearFilter={() => handleClearFilter(filterKey)}
        className="t-w-72"
      />
    </div>
  );
};
